// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* SelectField Component Styles */

:root {
  /* SelectField Components */
  --scl--cms-components-selectField-border-color: var(--input-defualt);
  --scl--cms-components-selectField-border-hover-color: var(--input-hover);
  --scl--cms-components-selectField-focus-color: #2388FF;
  --scl--cms-components-selectField-warning-color: #FFC18E;
  --scl--cms-components-selectField-error-color: #F8868A;
  --scl--cms-components-selectField-text-color: var(--typography-text-body-secondary);
  --scl--cms-components-selectField-label-color: #7D8187;
  --scl--cms-components-selectField-label-hover-color: var(--input-hover);
  --scl--cms-components-selectField-label-floating-bg: linear-gradient(108.2deg, #E9F0F8 0%, #FAFBFC 41.13%, #E9F0F8 96.11%);
  --scl--cms-components-selectField-chevron-color: var(--input-defualt);
  --scl--cms-components-selectField-dropdown-bg: #FFFFFF;
  --scl--cms-components-selectField-dropdown-shadow: rgba(0, 0, 0, 0.12);
  --scl--cms-components-selectField-option-hover-bg: var(--action-hover);
  --scl--cms-components-selectField-option-selected-bg: rgba(125, 129, 135, 0.2);
  --scl--cms-components-selectField-required-color: #EB5252;
  --scl--cms-components-selectField-search-border-color: rgba(255, 255, 255, 0.05);
  --scl--cms-components-selectField-search-input-text-color: #FFFFFF;
  --scl--cms-components-selectField-assistive-text-color: rgba(255, 255, 255, 0.54);
  --scl--cms-components-selectField-assistive-error-color: #FF5252;
  --scl--cms-components-selectField-scrollbar-track-bg: #393939;
  --scl--cms-components-selectField-scrollbar-thumb-bg: #1C1C1C;
  --scl--cms-components-selectField-scrollbar-thumb-hover-bg: #7D8187;
}

.scl--cms-components-selectField-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  width: 100%;
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
  position: relative;
}

.scl--cms-components-selectField-plate {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  width: 100%;
  height: 32px;
  border: 1px solid var(--scl--cms-components-selectField-border-color);
  border-radius: 3px;
  cursor: pointer;
  transition: border-color 0.3s ease;
  position: relative;
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
}

.scl--cms-components-selectField-plate:hover {
  border: 1px solid var(--scl--cms-components-selectField-border-hover-color);
}

.scl--cms-components-selectField-plate::after {
  content: '';
  position: absolute;
  left: -1px;
  bottom: -1px;
  width: calc(100% + 2px);
  height: 4px;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
  background: var(--scl--cms-components-selectField-focus-color);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.scl--cms-components-selectField-plate.scl--cms-components-selectField--open::after {
  opacity: 1;
}

.scl--cms-components-selectField-plate:hover:not(.scl--cms-components-selectField--open) {
  border-color: var(--scl--cms-components-selectField-border-hover-color);
}

.scl--cms-components-selectField-plate.scl--cms-components-selectField--open {
  border-color: var(--scl--cms-components-selectField-border-hover-color);
}

.scl--cms-components-selectField-plate.scl--cms-components-selectField--warning::after {
  background: var(--scl--cms-components-selectField-warning-color);
  opacity: 1;
}

.scl--cms-components-selectField-plate.scl--cms-components-selectField--error::after {
  background: var(--scl--cms-components-selectField-error-color);
  opacity: 1;
}

.scl--cms-components-selectField-plate.scl--cms-components-selectField--disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.scl--cms-components-selectField-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px 12px;
  gap: 12px;
  width: 100%;
  height: 32px;
  flex: 1;
  order: 0;
  flex-grow: 1;
  box-sizing: border-box;
}

.scl--cms-components-selectField-valueWrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0;
  height: 100%;
  flex: 1;
  order: 1;
  flex-grow: 1;
}

.scl--cms-components-selectField-textWrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0px;
  width: 100%;
  height: 100%;
  flex: 1;
  order: 0;
  flex-grow: 1;
  position: relative;
}

.scl--cms-components-selectField-text {
  display: flex;
  flex-direction: row;
  align-items: center;
  font-family: var(--scl--default-font);
  font-style: light;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.50px;
  color: var(--input-hover);
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.scl--cms-components-selectField-chevronIcon {
  width: 16px;
  height: 16px;
  flex: none;
  order: 1;

  transition: transform 0.3s ease, stroke 0.3s ease;
}

.scl--cms-components-selectField-chevronIcon path {
  stroke: var(--scl--cms-components-selectField-chevron-color);
  transition: stroke 0.3s ease;
}


.scl--cms-components-selectField-plate.scl--cms-components-selectField--open .scl--cms-components-selectField-chevronIcon {
  transform: rotate(180deg);
}

/* ✅ Floating Label Styles - Always visible, animates position */
.scl--cms-components-selectField-label {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  font-family: var(--scl--default-font);
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: var(--scl--cms-components-selectField-label-color);
  background: transparent;
  padding: 0 2px;
  margin: 0 -4px;
  pointer-events: none;
  transition: all 0.2s ease;
  z-index: 1;
  opacity: 1;
}

.scl--cms-components-selectField-label.scl--cms-components-selectField-label--floating {
  top: 0;
  left: 12px;
  transform: translateY(-50%);
  font-size: 12px;
  line-height: 16px;
  color: var(--input-hover);
  padding: 0 6px;
  margin: 0 -6px;
  background: transparent;
  position: absolute;
  z-index: 2;
}

.scl--cms-components-selectField-label.scl--cms-components-selectField-label--floating::before {
  content: "";
  position: absolute;
  left: 4px;
  right: 4px;
  top: 50%;
  transform: translateY(-50%);
  height: 2px;
  background: #F5F8FB;
  z-index: -1;
}

.scl--cms-components-selectField-plate:hover:not(.scl--cms-components-selectField--open) .scl--cms-components-selectField-label {
  color: var(--scl--cms-components-selectField-label-hover-color);
}

.scl--cms-components-selectField-plate:hover:not(.scl--cms-components-selectField--open) .scl--cms-components-selectField-label .scl--cms-components-selectField-requiredAsterisk {
  color: var(--scl--cms-components-selectField-required-color);
}

/* Required Asterisk Styles */
.scl--cms-components-selectField-requiredAsterisk {
  color: var(--scl--cms-components-selectField-required-color);
}

.scl--cms-components-selectField-dropdown {
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  right: 0;
  background: var(--scl--cms-components-selectField-dropdown-bg);
  border-radius: 2px;
  min-width: 115px;
  max-height: 280px;
  /* ← fixed, no animation */
  overflow: auto;
  /* ← always auto */
  z-index: 1000;
  box-shadow: 0px 4px 4px var(--scl--cms-components-selectField-dropdown-shadow);
  opacity: 0;
  transform: translateY(-6px);
  transition: opacity 0.2s ease, transform 0.2s ease, visibility 0s linear 0.2s;
  pointer-events: none;
  visibility: hidden;
}

.scl--cms-components-selectField-dropdown.scl--cms-components-selectField-dropdown--open {
  opacity: 1;
  transform: translateY(0px);
  pointer-events: auto;
  visibility: visible;
  transition: opacity 0.2s ease, transform 0.2s ease, visibility 0s linear 0s;
}

.scl--cms-components-selectField-search {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px 17px;
  gap: 14px;
  width: 100%;
  height: 37px;
  border-bottom: 1px solid var(--scl--cms-components-selectField-search-border-color);
}

.scl--cms-components-selectField-searchIcon {
  width: 20px;
  height: 17px;
  flex: none;
  flex-grow: 0;
}

.scl--cms-components-selectField-searchIcon path,
.scl--cms-components-selectField-searchIcon ellipse {
  stroke: var(--scl--cms-components-selectField-border-color);
}

.scl--cms-components-selectField-searchInput {
  width: 100%;
  background: transparent;
  border: none;
  outline: none;
  font-family: var(--scl--default-font);
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  color: var(--scl--cms-components-selectField-search-input-text-color);
  padding: 0;
  flex: 1;
  flex-grow: 1;
}

.scl--cms-components-selectField-searchInput::placeholder {
  color: var(--scl--cms-components-selectField-border-color);
}

.scl--cms-components-selectField-options {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 7px 0;
  gap: 0px;
  max-height: 230px;
  overflow-y: auto;
  background: #FFFFFF;
  width: 100%;
}

.scl--cms-components-selectField-option {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px 18px;
  gap: 10px;
  width: 100%;
  height: 30px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  box-sizing: border-box;
}

.scl--cms-components-selectField-option:hover {
  background-color: var(--scl--cms-components-selectField-option-hover-bg);
}


.scl--cms-components-selectField-option.scl--cms-components-selectField-option--selected {
  background-color: var(--scl--cms-components-selectField-option-selected-bg);
}

.scl--cms-components-selectField-optionIcon {
  display: none;
  width: 16px;
  height: 16px;
  flex: none;
  flex-grow: 0;
}

.scl--cms-components-selectField-optionIcon img {
  width: 16px;
  height: auto;
  object-fit: contain;
}

.scl--cms-components-selectField-optionLabel {
  font-family: var(--scl--default-font);
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: var(--scl--cms-components-selectField-border-color);
  flex: 1;
  flex-grow: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: all 0.2s ease;
}

.scl--cms-components-selectField-option:hover .scl--cms-components-selectField-optionLabel {
  color: var(--typography-text-body-primary);
}

.scl--cms-components-selectField-noOptions {
  padding: 12px 10px;
  font-family: var(--scl--default-font);
  font-size: 14px;
  color: var(--scl--cms-components-selectField-border-color);
  text-align: center;
  width: 100%;
  box-sizing: border-box;
}

/* Selected Icon in Input */
.scl--cms-components-selectField-selectedIcon {
  width: 20px;
  height: 16px;
  flex: none;
  flex-grow: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
}

.scl--cms-components-selectField-selectedIcon img {
  width: 20px;
  height: auto;
  object-fit: contain;
}

.scl--cms-components-selectField-assistive {
  position: absolute;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 2px 4px 2px 14px;
  height: 14px;
  font-family: var(--scl--default-font);
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 12px;
  letter-spacing: -0.15px;
  color: var(--scl--cms-components-selectField-assistive-text-color);
}

.scl--cms-components-selectField-assistive.scl--cms-components-selectField-assistive--error {
  color: var(--scl--cms-components-selectField-assistive-error-color);
}

/* Custom scrollbar for dropdown */
.scl--cms-components-selectField-options::-webkit-scrollbar {
  width: 2px;
}

.scl--cms-components-selectField-options::-webkit-scrollbar-track {
  background-color: white;
}

.scl--cms-components-selectField-options::-webkit-scrollbar-thumb {
  background: var(--scl--cms-components-selectField-scrollbar-thumb-hover-bg);
  border-radius: 0px;
}

.scl--cms-components-selectField-options::-webkit-scrollbar-thumb:hover {
  background: var(--scl--cms-components-selectField-scrollbar-thumb-hover-bg);
}`, "",{"version":3,"sources":["webpack://./src/component-controller-mod/component-serv/input-fs-cp/select-field-op/css/selectField.css"],"names":[],"mappings":"AAAA,iCAAiC;;AAEjC;EACE,2BAA2B;EAC3B,oEAAoE;EACpE,wEAAwE;EACxE,sDAAsD;EACtD,wDAAwD;EACxD,sDAAsD;EACtD,mFAAmF;EACnF,sDAAsD;EACtD,uEAAuE;EACvE,0HAA0H;EAC1H,qEAAqE;EACrE,sDAAsD;EACtD,sEAAsE;EACtE,sEAAsE;EACtE,8EAA8E;EAC9E,yDAAyD;EACzD,gFAAgF;EAChF,kEAAkE;EAClE,iFAAiF;EACjF,gEAAgE;EAChE,6DAA6D;EAC7D,6DAA6D;EAC7D,mEAAmE;AACrE;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,UAAU;EACV,QAAQ;EACR,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,qEAAqE;EACrE,kBAAkB;EAClB,eAAe;EACf,kCAAkC;EAClC,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,2EAA2E;AAC7E;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,WAAW;EACX,8BAA8B;EAC9B,+BAA+B;EAC/B,8DAA8D;EAC9D,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uEAAuE;AACzE;;AAEA;EACE,uEAAuE;AACzE;;AAEA;EACE,gEAAgE;EAChE,UAAU;AACZ;;AAEA;EACE,8DAA8D;EAC9D,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,UAAU;EACV,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,qCAAqC;EACrC,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,OAAO;EACP,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,QAAQ;;EAER,iDAAiD;AACnD;;AAEA;EACE,4DAA4D;EAC5D,4BAA4B;AAC9B;;;AAGA;EACE,yBAAyB;AAC3B;;AAEA,gEAAgE;AAChE;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,yDAAyD;EACzD,uBAAuB;EACvB,cAAc;EACd,cAAc;EACd,oBAAoB;EACpB,yBAAyB;EACzB,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,MAAM;EACN,UAAU;EACV,2BAA2B;EAC3B,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;EACd,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,+DAA+D;AACjE;;AAEA;EACE,4DAA4D;AAC9D;;AAEA,6BAA6B;AAC7B;EACE,4DAA4D;AAC9D;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,QAAQ;EACR,8DAA8D;EAC9D,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;EAC1B,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,8EAA8E;EAC9E,UAAU;EACV,2BAA2B;EAC3B,6EAA6E;EAC7E,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,0BAA0B;EAC1B,oBAAoB;EACpB,mBAAmB;EACnB,2EAA2E;AAC7E;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,mFAAmF;AACrF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;AACd;;AAEA;;EAEE,2DAA2D;AAC7D;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,qEAAqE;EACrE,UAAU;EACV,OAAO;EACP,YAAY;AACd;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,uBAAuB;EACvB,cAAc;EACd,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,eAAe;EACf,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA;EACE,wEAAwE;AAC1E;;;AAGA;EACE,2EAA2E;AAC7E;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,0DAA0D;EAC1D,OAAO;EACP,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,eAAe;EACf,0DAA0D;EAC1D,kBAAkB;EAClB,WAAW;EACX,sBAAsB;AACxB;;AAEA,2BAA2B;AAC3B;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,kEAAkE;AACpE;;AAEA;EACE,mEAAmE;AACrE;;AAEA,kCAAkC;AAClC;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,2EAA2E;EAC3E,kBAAkB;AACpB;;AAEA;EACE,2EAA2E;AAC7E","sourcesContent":["/* SelectField Component Styles */\n\n:root {\n  /* SelectField Components */\n  --scl--cms-components-selectField-border-color: var(--input-defualt);\n  --scl--cms-components-selectField-border-hover-color: var(--input-hover);\n  --scl--cms-components-selectField-focus-color: #2388FF;\n  --scl--cms-components-selectField-warning-color: #FFC18E;\n  --scl--cms-components-selectField-error-color: #F8868A;\n  --scl--cms-components-selectField-text-color: var(--typography-text-body-secondary);\n  --scl--cms-components-selectField-label-color: #7D8187;\n  --scl--cms-components-selectField-label-hover-color: var(--input-hover);\n  --scl--cms-components-selectField-label-floating-bg: linear-gradient(108.2deg, #E9F0F8 0%, #FAFBFC 41.13%, #E9F0F8 96.11%);\n  --scl--cms-components-selectField-chevron-color: var(--input-defualt);\n  --scl--cms-components-selectField-dropdown-bg: #FFFFFF;\n  --scl--cms-components-selectField-dropdown-shadow: rgba(0, 0, 0, 0.12);\n  --scl--cms-components-selectField-option-hover-bg: var(--action-hover);\n  --scl--cms-components-selectField-option-selected-bg: rgba(125, 129, 135, 0.2);\n  --scl--cms-components-selectField-required-color: #EB5252;\n  --scl--cms-components-selectField-search-border-color: rgba(255, 255, 255, 0.05);\n  --scl--cms-components-selectField-search-input-text-color: #FFFFFF;\n  --scl--cms-components-selectField-assistive-text-color: rgba(255, 255, 255, 0.54);\n  --scl--cms-components-selectField-assistive-error-color: #FF5252;\n  --scl--cms-components-selectField-scrollbar-track-bg: #393939;\n  --scl--cms-components-selectField-scrollbar-thumb-bg: #1C1C1C;\n  --scl--cms-components-selectField-scrollbar-thumb-hover-bg: #7D8187;\n}\n\n.scl--cms-components-selectField-container {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  padding: 0px;\n  width: 100%;\n  flex: none;\n  order: 0;\n  align-self: stretch;\n  flex-grow: 0;\n  position: relative;\n}\n\n.scl--cms-components-selectField-plate {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  width: 100%;\n  height: 32px;\n  border: 1px solid var(--scl--cms-components-selectField-border-color);\n  border-radius: 3px;\n  cursor: pointer;\n  transition: border-color 0.3s ease;\n  position: relative;\n  flex: none;\n  order: 0;\n  align-self: stretch;\n  flex-grow: 0;\n}\n\n.scl--cms-components-selectField-plate:hover {\n  border: 1px solid var(--scl--cms-components-selectField-border-hover-color);\n}\n\n.scl--cms-components-selectField-plate::after {\n  content: '';\n  position: absolute;\n  left: -1px;\n  bottom: -1px;\n  width: calc(100% + 2px);\n  height: 4px;\n  border-bottom-left-radius: 3px;\n  border-bottom-right-radius: 3px;\n  background: var(--scl--cms-components-selectField-focus-color);\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n\n.scl--cms-components-selectField-plate.scl--cms-components-selectField--open::after {\n  opacity: 1;\n}\n\n.scl--cms-components-selectField-plate:hover:not(.scl--cms-components-selectField--open) {\n  border-color: var(--scl--cms-components-selectField-border-hover-color);\n}\n\n.scl--cms-components-selectField-plate.scl--cms-components-selectField--open {\n  border-color: var(--scl--cms-components-selectField-border-hover-color);\n}\n\n.scl--cms-components-selectField-plate.scl--cms-components-selectField--warning::after {\n  background: var(--scl--cms-components-selectField-warning-color);\n  opacity: 1;\n}\n\n.scl--cms-components-selectField-plate.scl--cms-components-selectField--error::after {\n  background: var(--scl--cms-components-selectField-error-color);\n  opacity: 1;\n}\n\n.scl--cms-components-selectField-plate.scl--cms-components-selectField--disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.scl--cms-components-selectField-wrapper {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 0px 12px;\n  gap: 12px;\n  width: 100%;\n  height: 32px;\n  flex: 1;\n  order: 0;\n  flex-grow: 1;\n  box-sizing: border-box;\n}\n\n.scl--cms-components-selectField-valueWrapper {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 0;\n  height: 100%;\n  flex: 1;\n  order: 1;\n  flex-grow: 1;\n}\n\n.scl--cms-components-selectField-textWrapper {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0px;\n  width: 100%;\n  height: 100%;\n  flex: 1;\n  order: 0;\n  flex-grow: 1;\n  position: relative;\n}\n\n.scl--cms-components-selectField-text {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  font-family: var(--scl--default-font);\n  font-style: light;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  letter-spacing: 0.50px;\n  color: var(--input-hover);\n  flex: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.scl--cms-components-selectField-chevronIcon {\n  width: 16px;\n  height: 16px;\n  flex: none;\n  order: 1;\n\n  transition: transform 0.3s ease, stroke 0.3s ease;\n}\n\n.scl--cms-components-selectField-chevronIcon path {\n  stroke: var(--scl--cms-components-selectField-chevron-color);\n  transition: stroke 0.3s ease;\n}\n\n\n.scl--cms-components-selectField-plate.scl--cms-components-selectField--open .scl--cms-components-selectField-chevronIcon {\n  transform: rotate(180deg);\n}\n\n/* ✅ Floating Label Styles - Always visible, animates position */\n.scl--cms-components-selectField-label {\n  position: absolute;\n  left: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  font-family: var(--scl--default-font);\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  letter-spacing: 0.25px;\n  color: var(--scl--cms-components-selectField-label-color);\n  background: transparent;\n  padding: 0 2px;\n  margin: 0 -4px;\n  pointer-events: none;\n  transition: all 0.2s ease;\n  z-index: 1;\n  opacity: 1;\n}\n\n.scl--cms-components-selectField-label.scl--cms-components-selectField-label--floating {\n  top: 0;\n  left: 12px;\n  transform: translateY(-50%);\n  font-size: 12px;\n  line-height: 16px;\n  color: var(--input-hover);\n  padding: 0 6px;\n  margin: 0 -6px;\n  background: transparent;\n  position: absolute;\n  z-index: 2;\n}\n\n.scl--cms-components-selectField-label.scl--cms-components-selectField-label--floating::before {\n  content: \"\";\n  position: absolute;\n  left: 4px;\n  right: 4px;\n  top: 50%;\n  transform: translateY(-50%);\n  height: 2px;\n  background: #F5F8FB;\n  z-index: -1;\n}\n\n.scl--cms-components-selectField-plate:hover:not(.scl--cms-components-selectField--open) .scl--cms-components-selectField-label {\n  color: var(--scl--cms-components-selectField-label-hover-color);\n}\n\n.scl--cms-components-selectField-plate:hover:not(.scl--cms-components-selectField--open) .scl--cms-components-selectField-label .scl--cms-components-selectField-requiredAsterisk {\n  color: var(--scl--cms-components-selectField-required-color);\n}\n\n/* Required Asterisk Styles */\n.scl--cms-components-selectField-requiredAsterisk {\n  color: var(--scl--cms-components-selectField-required-color);\n}\n\n.scl--cms-components-selectField-dropdown {\n  position: absolute;\n  top: calc(100% + 8px);\n  left: 0;\n  right: 0;\n  background: var(--scl--cms-components-selectField-dropdown-bg);\n  border-radius: 2px;\n  min-width: 115px;\n  max-height: 280px;\n  /* ← fixed, no animation */\n  overflow: auto;\n  /* ← always auto */\n  z-index: 1000;\n  box-shadow: 0px 4px 4px var(--scl--cms-components-selectField-dropdown-shadow);\n  opacity: 0;\n  transform: translateY(-6px);\n  transition: opacity 0.2s ease, transform 0.2s ease, visibility 0s linear 0.2s;\n  pointer-events: none;\n  visibility: hidden;\n}\n\n.scl--cms-components-selectField-dropdown.scl--cms-components-selectField-dropdown--open {\n  opacity: 1;\n  transform: translateY(0px);\n  pointer-events: auto;\n  visibility: visible;\n  transition: opacity 0.2s ease, transform 0.2s ease, visibility 0s linear 0s;\n}\n\n.scl--cms-components-selectField-search {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 8px 17px;\n  gap: 14px;\n  width: 100%;\n  height: 37px;\n  border-bottom: 1px solid var(--scl--cms-components-selectField-search-border-color);\n}\n\n.scl--cms-components-selectField-searchIcon {\n  width: 20px;\n  height: 17px;\n  flex: none;\n  flex-grow: 0;\n}\n\n.scl--cms-components-selectField-searchIcon path,\n.scl--cms-components-selectField-searchIcon ellipse {\n  stroke: var(--scl--cms-components-selectField-border-color);\n}\n\n.scl--cms-components-selectField-searchInput {\n  width: 100%;\n  background: transparent;\n  border: none;\n  outline: none;\n  font-family: var(--scl--default-font);\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 21px;\n  color: var(--scl--cms-components-selectField-search-input-text-color);\n  padding: 0;\n  flex: 1;\n  flex-grow: 1;\n}\n\n.scl--cms-components-selectField-searchInput::placeholder {\n  color: var(--scl--cms-components-selectField-border-color);\n}\n\n.scl--cms-components-selectField-options {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n  padding: 7px 0;\n  gap: 0px;\n  max-height: 230px;\n  overflow-y: auto;\n  background: #FFFFFF;\n  width: 100%;\n}\n\n.scl--cms-components-selectField-option {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 10px 18px;\n  gap: 10px;\n  width: 100%;\n  height: 30px;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n  box-sizing: border-box;\n}\n\n.scl--cms-components-selectField-option:hover {\n  background-color: var(--scl--cms-components-selectField-option-hover-bg);\n}\n\n\n.scl--cms-components-selectField-option.scl--cms-components-selectField-option--selected {\n  background-color: var(--scl--cms-components-selectField-option-selected-bg);\n}\n\n.scl--cms-components-selectField-optionIcon {\n  display: none;\n  width: 16px;\n  height: 16px;\n  flex: none;\n  flex-grow: 0;\n}\n\n.scl--cms-components-selectField-optionIcon img {\n  width: 16px;\n  height: auto;\n  object-fit: contain;\n}\n\n.scl--cms-components-selectField-optionLabel {\n  font-family: var(--scl--default-font);\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  color: var(--scl--cms-components-selectField-border-color);\n  flex: 1;\n  flex-grow: 1;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  transition: all 0.2s ease;\n}\n\n.scl--cms-components-selectField-option:hover .scl--cms-components-selectField-optionLabel {\n  color: var(--typography-text-body-primary);\n}\n\n.scl--cms-components-selectField-noOptions {\n  padding: 12px 10px;\n  font-family: var(--scl--default-font);\n  font-size: 14px;\n  color: var(--scl--cms-components-selectField-border-color);\n  text-align: center;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n/* Selected Icon in Input */\n.scl--cms-components-selectField-selectedIcon {\n  width: 20px;\n  height: 16px;\n  flex: none;\n  flex-grow: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: 10px;\n}\n\n.scl--cms-components-selectField-selectedIcon img {\n  width: 20px;\n  height: auto;\n  object-fit: contain;\n}\n\n.scl--cms-components-selectField-assistive {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 2px 4px 2px 14px;\n  height: 14px;\n  font-family: var(--scl--default-font);\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 12px;\n  letter-spacing: -0.15px;\n  color: var(--scl--cms-components-selectField-assistive-text-color);\n}\n\n.scl--cms-components-selectField-assistive.scl--cms-components-selectField-assistive--error {\n  color: var(--scl--cms-components-selectField-assistive-error-color);\n}\n\n/* Custom scrollbar for dropdown */\n.scl--cms-components-selectField-options::-webkit-scrollbar {\n  width: 2px;\n}\n\n.scl--cms-components-selectField-options::-webkit-scrollbar-track {\n  background-color: white;\n}\n\n.scl--cms-components-selectField-options::-webkit-scrollbar-thumb {\n  background: var(--scl--cms-components-selectField-scrollbar-thumb-hover-bg);\n  border-radius: 0px;\n}\n\n.scl--cms-components-selectField-options::-webkit-scrollbar-thumb:hover {\n  background: var(--scl--cms-components-selectField-scrollbar-thumb-hover-bg);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
